export const baseURL = "/register-large-group";
export const startURL = "/start";
export const viewQuotesURL = "/view-quotes";
export const requestQuoteURL = "/request-quote";
export const existingBenefitsURL = "/existing-benefits";
export const shoppingURL = "/shopping";
export const shoppingHasCoverageURL = "/shopping-has-coverage";
export const companyInformationURL = "/company-information";
export const doneURL = "/done";

export const measurementMethodDocsURL = "https://www.irs.gov/affordable-care-act/employers/identifying-full-time-employees";
